module.exports = __webpack_public_path__ + "static/media/Choose_report.871853aa.svg";